module.exports = __webpack_public_path__ + "static/media/gestoria_amarillo.522fce04.svg";